import React from "react";
import { AppContextProvider } from "./AppContextProvider";

export default function AppProvider({ children }: any) {
  return <AppContextProvider>{children}</AppContextProvider>;
}
